import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderInfo } from '../../model/request-detail.model';
import { I18NextModule } from 'angular-i18next';
import { CommonModule } from '@angular/common';
import i18next from 'i18next';

@Component({
  standalone: true,
  selector: 'app-info-petitioner',
  templateUrl: './info-petitioner.component.html',
  styleUrls: ['./info-petitioner.component.scss'],
  imports: [CommonModule, I18NextModule]
})
export class InfoPetitionerComponent implements OnInit {
  @Input() user!: any;
  @Input() isDetail?: boolean;
  @Input() orderInfo?: OrderInfo;

  @Output() dataChange = new EventEmitter<{ email: string; phone: string }>();

  hasTelephones = true;
  endowmentMaxValue = 0;
  arrMaxValue = 0;
  extraEmail = '';
  extraPhone = '';
  phoneError = false;
  emailError = false;
  emptyData = i18next.t('noData');

  ngOnInit(): void {
    if (this.user?.phoneNumber && this.user?.mobileNumber) {
      this.hasTelephones = true;
    } else {
      this.hasTelephones = false;
    }
  }
}
